export type AiChatRole = "user" | "assistant";

export interface AiChatMessage {
  id: string;
  role: AiChatRole;
  text: string;
}

export interface AiChatHistoryTurn {
  message: string;
  type: AiChatRole;
}

export function toAiChatMessages(
  history: readonly AiChatHistoryTurn[] | undefined | null,
): AiChatMessage[] {
  if (!history) return [];
  return history.map((turn, index) => ({
    id: `${index}-${turn.type}`,
    role: turn.type,
    text: turn.message,
  }));
}
